// Note: the call types are ordered from "best" to "worst" so that clients can also use this list
// to determine the best call type available.
// Note: "video" = h.323 or sip video
// Note: This needs to be kept in sync with inara/js/drivers/util/CallsDevice.prototype.isInCall.
// We need to remove this dependency. One way is to convert all drivers to the new framework.
export const callTypes = ['googleMeet', 'teams', 'zoom', 'video', 'voip', 'pstn'];
